var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOnAir || _vm.isPlannedToAir)?_c('div',{staticClass:"on-air-container",attrs:{"title":_vm.showTooltip ? _vm.tooltip : ''}},[(_vm.isOnlyActive)?_c('div',{staticClass:"on-air-circle green accent-4 mx-1 my-1"}):_vm._e(),_vm._v(" "),(_vm.isOnlyPlanned)?_c('div',{staticClass:"on-air-circle orange accent-2 mx-1 my-1"}):_vm._e(),_vm._v(" "),(_vm.isBothActiveAndPlanned)?_c('div',{staticClass:"on-air-circle both-active-and-planned mx-1 my"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/OnAirIndicator.vue?vue&type=template&id=c2eb1164&scoped=true
// module id = 1338
// module chunks = 5